import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AccountAction, AgentsAvailable, LoginToken, LogOut, RolesAvailable, SelectClient, SelectProject } from './auth.actions';
import { AuthProject, AuthResponse, Organization, User } from '../models/user';

export class AuthStateModel {
  authResponse: AuthResponse = {
    user: {
      id: '',
      name: '',
      email: '',
      phone: '',
      enabled: false,
      superadmin: false,
      userOrganizations: [],
      userRoles: []
    },
    valid: false
  };
  agents: string[] = [];
  roles: string[] = [];
  token = '';
  isAuthenticated = false;
  isLogged = false;
  }

export const AuthStateDefaults: AuthStateModel = {
  authResponse: {
    user: {
      id: '',
      name: '',
      email: '',
      phone: '',
      enabled: false,
      superadmin: false,
      userOrganizations: [],
      userRoles: []
    },
    valid: false
  },
  agents: [],
  roles: [],
  token:'',
  isAuthenticated: false,
  isLogged: false,
};

export const organizationDefault: Organization = {
  id: '',
  name: '',
  description: '',
  path: '',
  contactName: '',
  contactEmail: '',
  contactPhone: '',
  enabled: false
}

export const projectDefault: AuthProject = {
  id: '',
  name: '',
  description: '',
  genaiOrganizationId: '',
  enabled: false
}

export class UserSelected {
  selectedClient!: Organization
  selectedProject!: AuthProject
}

@State<AuthStateModel>({
  name: 'auth',
  defaults: AuthStateDefaults
})
@Injectable({providedIn: 'root'})
export class AuthState {

  @Selector()
  static getToken(state:AuthStateModel) {
    if(state){
      return state.token;
    }
    return '';
  }

  @Selector()
  static isAuthenticated(state: AuthStateModel) {
    if(state){
      return state.isAuthenticated;
    }
    return false;
  }

  @Selector()
  static getAgents(state: AuthStateModel){
    if(state && state.agents){
      return state.agents;
    }
    return [];
  }

  @Selector()
  static getRoles(state: AuthStateModel){
    if(state && state.roles){
      return state.roles;
    }
    return [];
  }

  @Selector()
  static isLogged(state: AuthStateModel) {
    if(state){
      return state.isLogged;
    }
    return false;
  }

  @Selector()
  static getAccount(state:AuthStateModel) {
    if(state && state.authResponse){
      return state.authResponse;
    }
    return AuthStateDefaults.authResponse;
  }

  @Selector()
  static getSelectedClient(state:UserSelected){
    if(state && state.selectedClient){
      return state.selectedClient;
    }
    return organizationDefault;
  }

  @Selector()
  static getSelectedProject(state:UserSelected){
    if(state && state.selectedProject){
      return state.selectedProject;
    }
    return projectDefault;
  }

  @Action(LoginToken)
  token(
    ctx: StateContext<AuthStateModel>,
    action: LoginToken
  ){
    ctx.patchState({
      token: action.token,
      isLogged: true
    });
  }

  @Action(AccountAction)
  authenticate(
    ctx: StateContext<AuthStateModel>,
    action: AccountAction
  ){
    const currentState = ctx.getState();
    ctx.patchState({
      authResponse: action.payload,
      isAuthenticated: true,
    });
    const newState = ctx.getState();
  }

  @Action(AgentsAvailable)
  agentsAvailable(
    ctx: StateContext<AuthStateModel>,
    action: AgentsAvailable
  ){
    ctx.patchState({
      agents: action.agents
    });
  }

  @Action(RolesAvailable)
  rolesAvailable(
    ctx: StateContext<AuthStateModel>,
    action: RolesAvailable
  ){
    ctx.patchState({
      roles: action.roles
    })
  }

  @Action(LogOut)
  async logout(ctx: StateContext<AuthStateModel>){
    return ctx.patchState(AuthStateDefaults);
  }

  @Action(SelectClient)
  selectClient(
    ctx: StateContext<UserSelected>,
    action: SelectClient
  ){
    ctx.patchState({
      selectedClient: action.selectedClient
    })
  }

  @Action(SelectProject)
  selectProject(
    ctx: StateContext<UserSelected>,
    action: SelectProject
  ){
    ctx.patchState({
      selectedProject: action.selectedProject
    })
  }
}
